import { createContext } from 'react';
/**
 * @internal
 */

var LayoutGroupContext = createContext(null);
export { LayoutGroupContext };